export default "__VITE_ASSET__DFcdF5KS__"